//Proofed
import { Box, Container, Stack, Typography, Grid, Chip } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { FancyGoldButton } from './FancyGoldButton'
import { FancyLightButton } from './FancyLightButton'
import { COLOR_PRIMARY, NAVBAR_BG, DARK_800, SECTION_LIGHT, CHECKCIRCLE_SIZE } from '../theme'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { coreTiers } from '../common/PricingContent'

export function CorePricingSection() {
    return (
        <Box sx={{ ...SECTION_LIGHT }}>
            <Container maxWidth="lg">
                <Typography variant="h2" sx={{ textAlign: 'center', mb: 2 }}>Simple, transparent pricing</Typography>
                <Typography color="text.secondary" sx={{ textAlign: 'center', mb: 8, maxWidth: 480, mx: 'auto' }}>
                    All plans include a 14-day free trial. No commitment required.
                </Typography>
                <Grid container spacing={3} justifyContent="center">
                    {coreTiers.map(tier => (
                        <Grid item xs={12} md={4} key={tier.name}>
                            <Box sx={{
                                border: tier.highlight ? `2px solid ${COLOR_PRIMARY}` : '1px solid rgba(0,0,0,0.1)',
                                borderRadius: 3,
                                p: 3.5,
                                height: '100%',
                                position: 'relative',
                                boxShadow: tier.highlight ? `0 8px 40px ${COLOR_PRIMARY}20` : 'none',
                            }}>
                                {tier.highlight && (
                                    <Chip label="Most popular" size="small" sx={{ position: 'absolute', top: -13, left: '50%', transform: 'translateX(-50%)', backgroundColor: COLOR_PRIMARY, color: 'white', fontWeight: 700, fontSize: '11px' }} />
                                )}
                                <Typography variant="h5" sx={{ mb: 0.5 }}>{tier.name}</Typography>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }}>
                                    {tier.price.startsWith('From ') ? (
                                        <>
                                            <Typography component="span" color="text.secondary" variant="body2" sx={{ mr: 0.25 }}>From</Typography>
                                            <Typography sx={{ fontWeight: 800, fontSize: '42px', lineHeight: 1 }}>{tier.price.replace('From ', '')}</Typography>
                                        </>
                                    ) : (
                                        <Typography sx={{ fontWeight: 800, fontSize: '42px', lineHeight: 1 }}>{tier.price}</Typography>
                                    )}
                                    <Typography variant="caption">+VAT</Typography>
                                    <Typography color="text.secondary" variant="body1">{tier.period}</Typography>
                                </Box>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.5 }}>{tier.tagline}</Typography>
                                <Stack spacing={1.25} sx={{ mb: 4 }}>
                                    {tier.features.map(f => (
                                        f.included &&
                                        <Box key={f.text} sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                                            <CheckCircleIcon sx={{ fontSize: CHECKCIRCLE_SIZE, color: COLOR_PRIMARY, flexShrink: 0 }} />
                                            <Typography variant="body2">{f.text}</Typography>
                                        </Box>

                                    ))}
                                </Stack>
                                <FancyGoldButton to="/pricing" color={COLOR_PRIMARY} endIcon={<ArrowForwardIcon />} fullWidth>
                                    Start free trial
                                </FancyGoldButton>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container >
        </Box >
    )
}